import React, { useState } from 'react'
import { IconButton, Typography, Box, TextField, Tooltip } from '@mui/material'

import { withStyles } from '@mui/styles'
import {
  ArrowDownward,
  ArrowUpward,
  Close,
  Check,
  Edit,
} from '@mui/icons-material'

const IconButtonWithStyles = withStyles({
  root: {
    '&.Mui-disabled': {
      pointerEvents: 'auto',
    },
  },
})(IconButton)

const StageView = ({
  stage: s,
  index: i,
  stages,
  moveStage,
  removeStage,
  updateStage,
}) => {
  const [isEditingName, setIsEditingName] = useState(false)

  const getDeleteButton = (disabled = false) => {
    const adjustedButtonProps = {
      disabled: disabled,
      component: disabled ? 'div' : undefined,
      onClick: disabled ? undefined : () => removeStage(s),
    }
    return (
      <IconButtonWithStyles
        sx={{ ml: 1, pointerEvents: 'auto' }}
        {...adjustedButtonProps}
      >
        <Close />
      </IconButtonWithStyles>
    )
  }

  const canDelete = !s.cardsCount || s.cardsCount === 0
  return (
    <Box key={s.id} sx={{ display: 'flex', alignItems: 'center' }}>
      <Box
        className={`bgc-medium-${s.color}`}
        sx={{
          width: '500px',
          height: '38px',
          px: 1,
          py: 1,
          my: 0.5,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          flexShrink: 0,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <IconButton
            sx={{ mr: 1 }}
            onClick={() => setIsEditingName(!isEditingName)}
          >
            {isEditingName ? <Check /> : <Edit />}
          </IconButton>
          {/* NICE-TO-HAVE: add esc and enter for quality of life */}
          {isEditingName ? (
            <TextField
              autoFocus
              onChange={(e) => updateStage(s.id, { name: e.target.value })}
              size='small'
              value={s.name}
            />
          ) : (
            <Typography>{s.name}</Typography>
          )}
        </Box>
        <Box>
          <IconButton
            disabled={i === stages.length - 1}
            onClick={() => moveStage(i, 1)}
          >
            <ArrowDownward />
          </IconButton>
          <IconButton disabled={i === 0} onClick={() => moveStage(i, -1)}>
            <ArrowUpward />
          </IconButton>
        </Box>
      </Box>
      {canDelete && getDeleteButton()}
      {!canDelete && (
        <Tooltip title={'Remove cards from this stage before deleting'}>
          {getDeleteButton(true)}
        </Tooltip>
      )}
    </Box>
  )
}

export default StageView
